import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AdminLayout from '../../components/feature/AdminLayout';
import ComposePanel from './components/ComposePanel';
import NotificationsHistory from './components/NotificationsHistory';
import SystemNotificationsInbox from './components/SystemNotificationsInbox';
import { notificationsData } from '../../mocks/notifications';

type TabKey = 'inbox' | 'broadcast';

export default function NotificationsPage() {
  const { t } = useTranslation();
  const [refreshKey, setRefreshKey] = useState(0);
  const [tab, setTab] = useState<TabKey>('inbox');

  const sent  = notificationsData.filter((n) => n.status === 'sent');
  const total = notificationsData.filter((n) => n.status === 'sent').reduce((a, n) => a + n.sentTo, 0);
  const avgOpen = sent.length > 0 ? Math.round(sent.reduce((a, n) => a + n.openRate, 0) / sent.length) : 0;
  const last7   = notificationsData.filter((n) => n.status === 'sent').length;
  const today   = 1;

  return (
    <AdminLayout>
      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-2 p-1 bg-gray-100 rounded-xl w-fit">
          <button
            type="button"
            onClick={() => setTab('inbox')}
            className={`px-4 py-2 text-sm font-semibold rounded-lg transition-all cursor-pointer ${
              tab === 'inbox'
                ? 'bg-white text-teal-700 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <i className="ri-inbox-line me-1.5" />
            إشعارات النظام
          </button>
          <button
            type="button"
            onClick={() => setTab('broadcast')}
            className={`px-4 py-2 text-sm font-semibold rounded-lg transition-all cursor-pointer ${
              tab === 'broadcast'
                ? 'bg-white text-teal-700 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <i className="ri-send-plane-line me-1.5" />
            إرسال للمستأجرين
          </button>
        </div>

        {tab === 'inbox' ? (
          <SystemNotificationsInbox />
        ) : (
          <>
            <div className="grid grid-cols-4 gap-4">
              {[
                { label: t('notifications.summary.total_sent'), value: total.toLocaleString(), icon: 'ri-send-plane-line',       bg: 'bg-teal-50 text-teal-600'    },
                { label: t('notifications.summary.avg_open'),  value: `${avgOpen}%`,           icon: 'ri-eye-line',              bg: 'bg-emerald-50 text-emerald-600' },
                { label: t('notifications.summary.last_7'),    value: String(last7),            icon: 'ri-calendar-check-line',   bg: 'bg-amber-50 text-amber-600'  },
                { label: t('notifications.summary.today'),     value: String(today),            icon: 'ri-notification-badge-line',bg: 'bg-rose-50 text-rose-500'   },
              ].map((card) => (
                <div key={card.label} className="bg-white rounded-xl p-4 ring-1 ring-gray-100 flex items-center gap-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${card.bg}`}>
                    <i className={`${card.icon} text-lg`} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium">{card.label}</p>
                    <p className="text-xl font-bold text-gray-900">{card.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <ComposePanel onSent={() => setRefreshKey((k) => k + 1)} />
            <NotificationsHistory key={refreshKey} />
          </>
        )}
      </div>
    </AdminLayout>
  );
}
